import type { NetworkPayload } from "../../../composites";

const RESOURCE_URL = "card-linked-offers";

const API = {
  getCardLinkedOffers: (getRecommended = false): NetworkPayload => {
    const isTargeted = getRecommended ? "?is_targeted=true" : "";
    return {
      url: `${RESOURCE_URL}${isTargeted}`,
      options: {
        method: "GET",
        isJsonResponse: true,
      },
    };
  },
  getCardLinkedOffersEnrollmentStatus: (): NetworkPayload => {
    return {
      url: `${RESOURCE_URL}/enrollment`,
      options: {
        method: "GET",
        isJsonResponse: true,
      },
    };
  },
  createCardLinkedOffersEnrollment: (): NetworkPayload => {
    return {
      url: `${RESOURCE_URL}/enrollment`,
      options: {
        method: "POST",
        payload: {},
        isJsonResponse: false,
      },
    };
  },
  deleteCardLinkedOffersEnrollment: (): NetworkPayload => {
    return {
      url: `${RESOURCE_URL}/enrollment`,
      options: {
        method: "DELETE",
        isJsonResponse: false,
      },
    };
  },
};

export default API;
